import React from 'react';
import { displayLatLonInCompassFormat } from '@deckee/utilities';
import { fishAggregatingDevice } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Fish aggregating device',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'fad',
  icon: {
    baseShape: fishAggregatingDevice,
    iconColor: '#fff',
    markerColor: '#139ECA',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-points-of-interest',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'fishAttractingDeviceMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Fish aggregating device',
      itemTitleFunction: (item) =>
        (item &&
          item.geoJson &&
          item.geoJson.properties &&
          (item.geoJson.properties.title || item.geoJson.properties.bar)) ||
        'Fish aggregating device',
    },
    creationOptions: {
      menuText: 'Fish aggregating device',
      newTitle: 'Fish aggregating device',
      titlePlaceholder: 'Name of fish aggregating device',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker is used to indicate an fish aggregating device. Include
          information such as factors to be aware of, potential concerns, or any
          caution to be advised.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: false,
    title: 'Fish aggregating device',
    description:
      marker && marker.geoJson && marker.geoJson.properties
        ? marker.geoJson.properties.bar
        : displayLatLonInCompassFormat(marker.latLon),
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
